import React, { Component } from 'react';
import { Icon, Tooltip } from 'grab-ui';
import './barItem.css';

type Props = {
  name: string,
  value: number,
  width: number,
  height: number,
  totalHeight: number,
  color: string,
  shadowColor: string,
  targetValue: string,
  description?: string,
}

export default class BarItem extends Component {

  constructor(props: Props) {
    super(props);
    this.state = {
      bar: React.createRef(),
      targetValueRef: React.createRef(),
      targetValues: [0],
    };
  }

  generateRandomNumbers() {
    const targetNumber = this.props.value;
    let targetValues = [];
    for (let i = 0; i < 10; i++) {
      targetValues = targetValues.concat(
        Math.floor(Math.random() * targetNumber),
      );
    }
    targetValues = targetValues.concat(this.props.targetValue);
    targetValues = targetValues.sort((a, b) => a - b);
    this.setState({ targetValues });
  }

  scrollNumbers() {
    this.generateRandomNumbers();
    const ref = this.state.targetValueRef.current;
    ref.className = 'scroller';
  }

  drawShadowRectangle() {
    const canvas = this.state.bar.current;
    const color = this.props.color;
    const canvasHeight = canvas.height;
    const canvasWidth = canvas.width;
    const ctx = canvas.getContext('2d');
    let currentHeight = 0;
    const timerID = setInterval(() => {
      if (currentHeight === canvasHeight) {
        clearInterval(timerID);
      }
      ctx.beginPath();
      ctx.rect(0, 0, canvasWidth, currentHeight);
      ctx.fillStyle = color;
      ctx.fill();
      currentHeight += 5;
    }, 40);
  }

  componentDidMount() {
    this.drawShadowRectangle();
    this.scrollNumbers();
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          borderLeft: '1px solid #E8E8E8',
          width: `${this.props.width}%`,
          height: `${this.props.totalHeight + 100}px`,
        }}
      >
        <div style={{ marginLeft: '16px' }}>
          <div style={{ display: 'flex' }}>
            <div style={{ color: '#707070' }}>{this.props.name}</div>
            {this.props.description && (
              <div style={{ marginLeft: '4px' }}>
                <Tooltip title={this.props.description}>
                  <div>
                    <Icon type="grabicon-information-02" />
                  </div>
                </Tooltip>
              </div>
            )}
          </div>
          <div
            style={{
              fontSize: '24px',
              color: '#1A1A1A',
              height: '50px',
              overflow: 'hidden',
            }}
          >
            <div
              ref={this.state.targetValueRef}
              style={{ position: 'relative' }}
            >
              {this.state.targetValues.map((value, index) => (
                <div style={{ padding: '2px' }}>{value}</div>
              ))}
            </div>
          </div>
        </div>
        <div style={{ marginTop: '20px' }}>
          <div
            style={{
              height: `${this.props.totalHeight}px`,
              backgroundColor: this.props.shadowColor,
              transform: 'rotateX(180deg)',
              display: 'flex',
            }}
          >
            <canvas
              style={{
                width: '100%',
                height: `${this.props.height}px`,
              }}
              ref={this.state.bar}
            />
          </div>
        </div>
      </div>
    );
  }
}
